import { Quote } from 'models/Quote';
import { Box, Flex, Heading, Paragraph } from 'theme-ui';
import { getRateTypeDetails } from 'helpers/RateDetailsHelper';

type Props = {
  title: string;
  quote?: Quote;
  isLongTerm?: boolean;
  phone?: string;
}
export const ChargeDetails: React.FC<Props> = ({ title, quote, isLongTerm, phone }) => {

  const getRateDetails = () => {
    const dailyDetails = getRateTypeDetails(quote.rateDetailSummary?.daily, 'nights');
    const monthlyDetails = getRateTypeDetails(quote.rateDetailSummary?.monthly, 'months');
    const result = [...dailyDetails, ...monthlyDetails];

    return result;
  };

  return (
    <>
      <Heading>{title}</Heading>
      {!quote && !isLongTerm && (
        <Paragraph mb={8}>
          Please complete your reservation details
          to see your reservation amount
        </Paragraph>
      )}
      {!quote && isLongTerm && (
        <Paragraph mb={8}>
          Looks like you're trying to book a reservation over 30 days. <br />
          For long-term stays, please contact us at <br />
          {phone}.
        </Paragraph>
      )}
      {quote && !quote.availableSites && (
        <Paragraph mb={8}>
          Oh no! There are no available sites that match those dates. <br />
          Please choose alternative dates or a different site type.
        </Paragraph>
      )}
      {quote?.availableSites > 0 && (
        <Box my={16}>
          {getRateDetails().map(item => (
            <Line key={item.rate} text={`$${item.rate} x ${item.count} ${item.unit}`} value={item.subtotal} />
          ))}
          <Line text="Additional Fees" value={quote.transactionFee} />
          <Line text="Taxes &amp; fees" value={quote.tax} />
          {quote.discount > 0 && (
            <Line text="Discount" value={quote.discount * -1} />
          )}
          <Line bold text="Total" value={quote.total} />
        </Box>
      )}
    </>
  );
};

const Line = ({ text, value, bold = false }) => {
  return (
    <Flex sx={{justifyContent: 'space-between', lineHeight: 2.5, fontWeight: bold ? 'bold' : undefined }}>
      <div>{text}</div>
      <data>${value.toFixed(2)}</data>
    </Flex>
  )
}

// type FlexProps = StyledSystem.FlexboxProps[''];
// const Flex: React.FC<FlexProps> = ({ children, a }) => (
//   <Box sx={{display: 'flex', ...sx, }}>{props.}</Box>
// )